<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editMap.id ? $t('map.edit') : $t('map.new') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">{{ $t('map.nameLabel') }}</label>
						<div class="control">
							<input
								type="text"
								v-model="map.name"
								class="input"
								:placeholder="$t('map.namePlaceholder')"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('map.fileLabel') }}</label>
						<div class="file has-name is-fullwidth is-dark">
							<label class="file-label">
								<input
									class="file-input"
									type="file"
									name="resume"
									accept="image/*"
									@change="upLoadImage"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-upload"></i>
									</span>
									<span class="file-label">
										{{ $t('map.selectImage') }}
									</span>
								</span>
								<span class="file-name">
									{{ fileName }}
								</span>
							</label>
						</div>
					</div>
					<img v-if="imgSrc" class="image-preview" :src="imgSrc" />
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('map.save') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editMap: Object
	},
	data() {
		return {
			map: {
				name: '',
				file: null
			},
			isLoading: false,
			imgSrc: ''
		};
	},
	computed: {
		disableSave() {
			return this.map.name == '' ? true : false;
		},
		fileName() {
			return this.map.file ? this.map.file.name : this.$t('map.noFileSelected');
		}
	},
	methods: {
		save() {
			if (!this.isLoading) {
				this.$emit('save', this.map);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		},
		upLoadImage(event) {
			this.map.file = event.target.files[0];

			if (this.editMap.file) this.map.oldFileId = this.editMap.file.id;

			let reader = new FileReader();
			reader.onload = event => {
				this.imgSrc = event.target.result;
			};
			reader.readAsDataURL(event.target.files[0]);
		}
	},
	created() {
		if (this.editMap) {
			Object.assign(this.map, this.editMap);
		}
	}
};
</script>

<style lang="scss" scoped>
.image-preview {
  width: 100%;
  margin-bottom: -7px;
}
</style>
